import params from 'Cloud/Application/Params';
import browser from 'Cloud/browser';

const mobileType = params.getParam('MOBILE_BROWSER');
const isPhone = !!params.getParam('PHONE_BROWSER');
const isWebview = !!params.getParam('IS_WEBVIEW');
const isHuawei = params.getParam('EMORB_VENDOR') === 'Huawei';

const getMobileType = () => mobileType;
const isMobile = () => !!getMobileType();

export const EnvironmentSelectors = {
    isMobile,
    getMobileType,
    isHuawei: () => isHuawei,
    isPhone: () => isPhone,
    isWebview: () => isWebview,
    isIE: () => browser.isIE(),
    isIpadOs: () => browser.isIpadOs(),
    isMac: () => browser.isMac(),
    getIOsVersion: () => browser.getIOsVersion(),
};
